export default {"src":"/_next/static/media/resource.5aba505b.svg","height":24,"width":19};